module.exports = __webpack_public_path__ + "img/便便.e158f7c9.png";